'use strict';

var index = require('../constants/index.cjs');

function isValidLocale(maybeLocale) {
  if (typeof maybeLocale === "string") {
    return index.locales.some((it) => it === maybeLocale);
  }
  return false;
}

exports.isValidLocale = isValidLocale;
//# sourceMappingURL=index.cjs.map
